import { Tooltip, Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import useStyles from './styles';

const InfoBox = ({title, tooltip, value}) => {
    const classes = useStyles();
    return(
  <Box className={classes.outerContainer}
  >
      <Box className={classes.title}>
          {title}
      </Box>
      <Box className={classes.innerContainer}>          
        <Tooltip
        placement="right"
        title={tooltip}
        >
            <InfoIcon
                className={classes.infoIcon}
                fontSize="small"
                color='black'
                border="2px solid black"
            />
        </Tooltip>
        <Typography variant="span" className={classes.boldText}>
            {value}
        </Typography>
      </Box>
  </Box>
)}
export default InfoBox;